import NumericInput from "@/modules/common/components/ui-kit/inputs/numeric-input";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Rank } from "@/modules/user/types/index.v2";
import {
  useRankTarget,
  getMonthKey,
} from "@/modules/targets/hooks/rank-targets.hook";
import { TargetTemplateType } from "@/modules/targets/types";
import { targetTypeLabels } from "@/modules/targets/constants";

interface TargetInputsProps {
  targetType: TargetTemplateType;
  rank: Rank;
}

const TargetInputs = ({ targetType, rank }: TargetInputsProps) => {
  const theme = useTheme();
  const { currentTarget, updateTarget } = useRankTarget(rank, targetType);
  const total = currentTarget.m1 + currentTarget.m2 + currentTarget.m3;

  return (
    <Stack direction="column" spacing={theme.nawy.spacing.xxs}>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ color: theme.nawy.colors.semantic.text.primary }}
      >
        <Typography
          sx={theme.nawy.typography.english.variants.body.md.regular}
          textTransform="capitalize"
        >
          {targetTypeLabels[targetType]}
        </Typography>
        <Typography
          sx={theme.nawy.typography.english.variants.body.md.semibold}
        >
          {total} EGP
        </Typography>
      </Stack>

      <Stack
        direction={{ mobile: "column", tablet: "row" }}
        gap={theme.nawy.spacing.xs}
      >
        {(["month1", "month2", "month3"] as const).map((month, idx) => {
          const key = getMonthKey(month);
          return (
            <NumericInput
              key={month}
              label={`M${idx + 1}`}
              placeholder={`M${idx + 1}`}
              value={currentTarget[key] || ""}
              onChange={(e) => updateTarget(month, Number(e.target.value))}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default TargetInputs;
